import { useCallback, useEffect, useRef } from 'react'

/*
 * Returns a scroll handler that keeps the scrollLeft of multiple refs in sync.
 * Skips the event source and skips already-aligned nodes to break feedback loops.
 */
const useScrollSync = refs => {
  const refsRef = useRef(refs)
  useEffect(() => { refsRef.current = refs })
  return useCallback(event => {
    const left = event.target.scrollLeft
    refsRef.current.forEach(ref => {
      const node = ref.current
      if (node && node !== event.target && node.scrollLeft !== left)
        node.scrollLeft = left
    })
  }, [])
}

export default useScrollSync
